import { Icon, forwardRef } from "@chakra-ui/react";
import * as React from "react";
export const SvgStopIcon = forwardRef((props, ref) => {
  return /* @__PURE__ */ React.createElement(Icon, { ref, color: "foreground.secondary", fill: "none", focusable: "false", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { fill: "currentColor", height: 10, rx: 2, width: 10, x: 3, y: 3 }));
});
export default SvgStopIcon;
